import Icon from '@components/utils/Icon'

import { scopedTranslation } from '@utils/I18n'

import useUndoShiftRemovalMutation from './useUndoShiftRemovalMutation'

const t = scopedTranslation('roster_board')

export function UndoRemovalButton({ shiftId, onChange }: { shiftId: string; onChange: () => void }) {
  const { undoShiftRemoval, isPending } = useUndoShiftRemovalMutation()

  const handleUndo = () => {
    undoShiftRemoval({ id: shiftId, onSuccess: onChange })
  }

  return (
    <button
      type="button"
      onClick={handleUndo}
      disabled={isPending}
      className="tw:inline-flex tw:shrink-0 tw:items-center tw:gap-1.5 tw:whitespace-nowrap tw:rounded tw:text-xs tw:font-semibold tw:text-primary-700 tw:hover:text-primary-800 tw:focus:outline-hidden tw:focus-visible:ring-2 tw:focus-visible:ring-primary-400"
    >
      <Icon type="flip-backwards" className="tw:h-3.5 tw:w-3.5" aria-hidden /> {t('undo_removal')}
    </button>
  )
}
